export default "__VITE_ASSET__ebefa56b__"